import React from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import Error from "../../../components/common/Error/Error";
import Loading from "../../../components/common/Loading/Loading";
import {getAdmins} from "../../../store/admins/actions";
import {
    fetchApp,
    deleteApp,
    deleteAdmin,
    addAdmin,
    postAppPicture,
    deleteAppPicture
} from '../../../store/apps/actions';
import style from '../../../styles/styles';
import styles from './ApplicationPage.css';
import ApplicationFull from "../../../components/application/ApplicationFull/ApplicationFull";
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import {grey400} from 'material-ui/styles/colors';
import {Link} from "react-router-dom";
import AdminService, {SUPER_ADMIN} from '../../../services/admin';
import {SelectField} from "material-ui";
import withTranslation from "../../../hoc/withTranslation";
import {EDIT_APPLICATION_PAGE, HOMEPAGE, SETTING_PAGE} from "../../../constants/routes";

const iconButtonElement = (
    <IconButton
        touch={true}
        tooltipPosition="bottom-left"
    >
        <MoreVertIcon color={grey400} />
    </IconButton>
);

export class ApplicationPage extends React.Component {

    static propTypes = {
        app: PropTypes.object
    };

    static defaultProps = {
        admins: [],
        loading: true,
        app: null
    };

    state = {
        openRemoveApp: false,
        openAddAdmin: false,
        adminToAdd: null,
        openRemoveAdmin: false,
        adminToRemove: null
    };

    componentWillMount() {
        if (AdminService.isAuthorized(SUPER_ADMIN, this.props.user) && this.props.admins.length === 0) {
            this.props.getAdmins();
        }
        this.fetchApplication();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.sending && !nextProps.sending) {
            if (!nextProps.app) { // App has been deleted
                this.props.history.push(HOMEPAGE);
            } else if (this.state.adminToRemove) { // admin has been deleted
                this.handleCloseAdmin()
            } else if (this.state.adminToAdd) { // admin has been added
                this.handleCloseAddAdmin()
            }
        }
        if (this.props.match !== nextProps.match) {
            this.fetchApplication(nextProps.match.params.appId);
        }
    }

    // Delete app

    handleOpenApp = () => {
        this.setState({openRemoveApp: true});
    };

    handleCloseApp = () => {
        this.setState({openRemoveApp: false});
    };

    deleteApp = () => {
        this.props.deleteApp(this.props.app.id);
    };

    // Add admin

    handleSelectAdminToAdd = (event, index, value) => {
        this.setState({adminToAdd: value});
    };

    handleOpenAddAdmin = () => {
        this.setState({openAddAdmin: true});
    };

    handleCloseAddAdmin = () => {
        this.setState({
            openAddAdmin: false,
            adminToAdd: null
        });
    };

    addAdmin = (admin) => {
        this.props.addAdmin(this.props.app.id, this.state.adminToAdd);
    };

    // Delete admin

    handleDeleteAdmin = (admin) => {
        this.setState({
            openRemoveAdmin: true,
            adminToRemove: admin
        });
    };

    handleCloseAdmin = () => {
        this.setState({
            openRemoveAdmin: false,
            adminToRemove: null
        });
    };

    deleteAdmin = () => {
        this.props.deleteAdmin(this.props.app.id, this.state.adminToRemove.id);
    };

    fetchApplication(appId = null) {
        if (this.props.match) {
            let id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id)
            }
        }
    }

    renderMenu() {
        let menu;

        if (AdminService.isAuthorized(SUPER_ADMIN, this.props.user)) {
            menu = (
                <IconMenu
                    style={styles.buttons}
                    iconButtonElement={iconButtonElement}
                    anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                    targetOrigin={{horizontal: 'right', vertical: 'top'}}
                >
                    <Link to={SETTING_PAGE.replace(':appId', this.props.app.id)}>
                        <MenuItem>
                            {this.props.t('generic.settings')}
                        </MenuItem>
                    </Link>
                    <Link to={EDIT_APPLICATION_PAGE.replace(':appId', this.props.app.id)}>
                        <MenuItem>
                            {this.props.t('generic.edit')}
                        </MenuItem>
                    </Link>
                    <MenuItem onClick={this.handleOpenAddAdmin}>
                        {this.props.t('page_app.add_admin')}
                    </MenuItem>
                    <MenuItem onClick={this.handleOpenApp}>
                        {this.props.t('generic.remove')}
                    </MenuItem>
                </IconMenu>
            );
        }

        return menu;
    };

    renderAddAdminDialog() {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.sending}
                onClick={this.handleCloseAddAdmin}
            />,
            <FlatButton
                label={this.props.t('generic.add')}
                disabled={this.state.adminToAdd === null || this.props.sending}
                onClick={this.addAdmin}
                primary={true}
            />
        ];

        let items = this.props.admins
        // Admin doesn't already belong to the app
            .filter(admin => {
                return this.props.app.admins.find(appAdmin => appAdmin.id === admin.id) === undefined
            })
            // Admin isn't super admin
            .filter(admin => {
                return admin.role !== SUPER_ADMIN
            })
            .map((admin) => {
                return (
                    <MenuItem
                        key={admin.id}
                        value={admin.id}
                        primaryText={`${admin.firstname} ${admin.lastname} (${admin.username})`}
                        secondaryText={AdminService.roleName(admin)}
                    />
                );
            });

        // Dialog opened and empty admins
        if (this.state.openAddAdmin && this.props.admins.length === 0) {
            this.props.getAdmins();
        }

        return (
            <Dialog
                title={this.props.t('page_app.add_admin')}
                actions={actions}
                modal={this.props.sending}
                open={this.state.openAddAdmin}
                onRequestClose={this.handleCloseAddAdmin}
            >
                <div>
                    {(this.props.adminsLoading || this.props.sending) && <Loading paper={false} />}
                    {!this.props.adminsLoading && !this.props.sending &&
                    <div>
                        <div dangerouslySetInnerHTML={{
                            __html: this.props.t('page_app.add_admin_hint', {appName: this.props.app.name})
                        }} />
                        <SelectField
                            floatingLabelText={this.props.t('generic.admin')}
                            value={this.state.adminToAdd}
                            onChange={this.handleSelectAdminToAdd}
                            fullWidth={true}
                        >
                            {items}
                        </SelectField>
                    </div>
                    }
                </div>
            </Dialog>
        );
    }

    renderDeleteAppDialog() {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.sending}
                onClick={this.handleCloseApp}
            />,
            <FlatButton
                label={this.props.t('generic.delete')}
                primary={true}
                disabled={this.props.sending}
                onClick={this.deleteApp}
            />
        ];

        return (
            <Dialog
                title={this.props.t('page_app.remove_app')}
                actions={actions}
                modal={this.props.sending}
                open={this.state.openRemoveApp}
                onRequestClose={this.handleCloseApp}
            >
                {this.props.sending && <Loading paper={false} />}
                {!this.props.sending &&
                <p>{this.props.t('page_app.remove_app_confirmation')}</p>
                }
            </Dialog>
        );
    }

    renderDeleteAdminDialog(admin) {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.sending}
                onClick={this.handleCloseAdmin}
            />,
            <FlatButton
                label={this.props.t('generic.delete')}
                primary={true}
                disabled={this.props.sending}
                onClick={this.deleteAdmin}
            />
        ];

        return (
            <Dialog
                actions={actions}
                title={this.props.t('page_app.remove_admin')}
                modal={this.props.sending}
                open={this.state.openRemoveAdmin}
                onRequestClose={this.handleCloseAdmin}
            >
                {this.props.sending && <Loading paper={false} />}
                {!this.props.sending &&
                <p>
                    <div dangerouslySetInnerHTML={{
                        __html: this.props.t('page_app.remove_admin_confirmation', {
                            firstname: admin.firstname,
                            lastname: admin.lastname
                        })
                    }} />
                </p>
                }

            </Dialog>
        );
    }

    render() {
        if (this.props.appError) {
            return (
                <Error
                    title={this.props.t('generic.error')}
                    subtitle={this.props.t('generic.error_loading')}
                    paper={true}
                />
            );
        } else if (this.props.loading || !this.props.app) {
            return <Loading paper={false} />;
        } else {
            return (
                <div>
                    {this.renderMenu()}
                    {this.renderDeleteAppDialog()}
                    {this.renderAddAdminDialog()}
                    {this.state.adminToRemove && this.renderDeleteAdminDialog(this.state.adminToRemove)}

                    <h3 style={style.navigation}>{this.props.t('generic.application')} / {this.props.t('generic.detail')} - {this.props.app.name}</h3>
                    <ApplicationFull
                        app={this.props.app}
                        user={this.props.user}
                        handleRemoveAdmin={this.handleDeleteAdmin}
                        postPicture={this.props.postAppPicture}
                    />
                </div>
            )
        }
    }
}

function mapStateToProps(state, ownProps) {
    let props = {
        user: state.auth.content,
        loading: state.apps.pending,
        sending: state.apps.sending,
        appError: state.apps.error,
        admins: state.admins.content,
        adminsLoading: state.admins.pending
    };

    if (state.apps.currentApplication) {
        props.app = state.apps.currentApplication;
    }

    return props;
}

export default connect(mapStateToProps, {
    postAppPicture,
    deleteAppPicture,
    fetchApp,
    deleteApp,
    deleteAdmin,
    getAdmins,
    addAdmin
})(withTranslation(ApplicationPage));



// WEBPACK FOOTER //
// src/containers/application/ApplicationPage/ApplicationPage.js